import * as ConfigureReactWidgets from "@framework/ConfigureReactWidgets"
import * as ReactWidgets from 'react-widgets';
import * as moment from 'moment-jalaali';

import { DateTime, Settings } from "luxon";
import { currentCulture } from "@framework/AppContext";
import { ValueLineController } from "../../Framework/Signum.React/Scripts/Lines/ValueLine";

  
export function getDateLocalizer(maxTwoDigitYear?: number): ReactWidgets.DateLocalizer<string> {
  Settings.defaultOutputCalendar = currentCulture ?? "fa";

  const localField = typeof moment.locale === 'function' ? 'locale' : 'lang',
    hasLocaleData = !!moment.localeData;

  if (!hasLocaleData) throw new TypeError('The Moment localizer depends on the `localeData` api, please provide a moment object v2.2.0 or higher');

  function getMoment(value: any, format: string | undefined) {
    if (globalIsPersian())
      return (moment(value, format) as any)[localField]("fa");

    return moment(value, format);
  }

  moment.loadPersian({ dialect: "persian-modern" });

  var maxTwoDigitYearDefault = maxTwoDigitYear ?? DateTime.local().year + 10;

  function endOfDecade(date: Date) {
    if (globalIsPersian()) {
      const md = moment(date);
      md.jYear(Math.floor(md.jYear() / 10) * 10 + 9);
      // md.jMonth(11).day(29 + +moment.jIsLeapYear(md.jYear())).endOf('day')  // workaround for moment-jalaali baag
      // md.endOf('jYear'); // momentJalaali turns end of 1359 to the beginning of 1360
      return md.toDate();
    }
    return DateTime.fromJSDate(date).plus({ years: 10 }).minus({ months: 1 }).toJSDate();
  }

  function endOfCentury(date: Date) {
    if (globalIsPersian()) {
      const md = moment(date);
      md.jYear(Math.floor(md.jYear() / 100) * 100 + 99);
      return md.toDate();
    }
    return DateTime.fromJSDate(date).plus({ years: 100 }).minus({ millisecond: 1 }).toJSDate();
  }

  return {
    date: (date, format) => DateTime.fromJSDate(date).toFormat(format ?? "D"),
    time: (date, format) => DateTime.fromJSDate(date).toFormat(format ?? "t"),
    datetime: (date, format) => DateTime.fromJSDate(date).toFormat(format ?? "FF"),
    header: (date, format) => DateTime.fromJSDate(date).toFormat(format ?? "MMMM yyyy"),
    weekday: (date, format) => DateTime.fromJSDate(date).toFormatFixed(format ?? "EE"),
    dayOfMonth: (date, format) => DateTime.fromJSDate(date).toFormat(format ?? "dd"),
    month: (date, format) => DateTime.fromJSDate(date).toFormat(format ?? "MMM"),
    year: (date, format) => DateTime.fromJSDate(date).toFormat(format ?? "yyyy"),
    decade: (date, format) => DateTime.fromJSDate(date).toFormat(format ?? 'yyyy') + ' - ' + DateTime.fromJSDate(endOfDecade(date)).toFormat(format ?? 'yyyy'),
    century: (date, format) => DateTime.fromJSDate(date).toFormat(format ?? 'yyyy') + ' - ' + DateTime.fromJSDate(endOfCentury(date)).toFormat(format ?? 'yyyy'),

    firstOfWeek: function firstOfWeek(): number {
      var day = ConfigureReactWidgets.firstDay[Settings.defaultLocale?.tryAfter("-") ?? "IR"];

      switch (day) {
        case "sun": return 0;
        case "mon": return 1;
        case "fri": return 5;
        case "sat": return 6;
        default: throw new Error("Unexpected " + day);
      }
    },

    parse: function parse(value: any, format?: string) {
      if (value == null || value == "")
        return null;

      var moment = getMoment(ValueLineController.autoFixString(value, true), "L LT");
      var d = moment.toDate();
      if (moment.isValid())
        return moment.toDate();

      return undefined;
    },
  };
}

function globalIsPersian() {
  return moment.locale() == "fa";
}
